/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ChanPinChaXunShiTiLei,
  ChanPinXinZengXinXi,
  ResponseApiChanPinXinXi,
  ResponseApiInt,
  ResponseApiIPageChanPinLieBiaoXiangYingXinXi,
  ResponseApiListChanPinXinZengXinXi,
  ResponseApiStatisticsIPageChanPinLieBiaoXiangYingXinXiAdStatDataDTO,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class ChanPinGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags ChanPinGuanLi
   * @name ProductListUsingPost
   * @summary 分页查询产品列表,包含指标数据
   * @request POST:/dsp-admin/api/products
   * @secure
   */
  productListUsingPost = (
    查询条件参数: ChanPinChaXunShiTiLei,
    params: RequestParams = {},
  ) =>
    this.request<
      ResponseApiStatisticsIPageChanPinLieBiaoXiangYingXinXiAdStatDataDTO,
      void
    >({
      path: `/dsp-admin/api/products`,
      method: "POST",
      body: 查询条件参数,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChanPinGuanLi
   * @name GetProductsByAdvertiserUsingPost
   * @summary 查询广告主下的所有产品
   * @request POST:/dsp-admin/api/products/advertiser/{advertiserId}
   * @secure
   */
  getProductsByAdvertiserUsingPost = (
    advertiserId?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiListChanPinXinZengXinXi, void>({
      path: `/dsp-admin/api/products/advertiser/${advertiserId}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChanPinGuanLi
   * @name CreateProductUsingPost
   * @summary 创建产品
   * @request POST:/dsp-admin/api/products/create
   * @secure
   */
  createProductUsingPost = (
    productCreateDTO: ChanPinXinZengXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiInt, void>({
      path: `/dsp-admin/api/products/create`,
      method: "POST",
      body: productCreateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChanPinGuanLi
   * @name GetProductsByIndustryUsingPost
   * @summary 根据一级行业查询产品
   * @request POST:/dsp-admin/api/products/industry/{primaryIndustry}
   * @secure
   */
  getProductsByIndustryUsingPost = (
    primaryIndustry?: string,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiListChanPinXinZengXinXi, void>({
      path: `/dsp-admin/api/products/industry/${primaryIndustry}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChanPinGuanLi
   * @name GetProductUsingPost
   * @summary 查询产品详情
   * @request POST:/dsp-admin/api/products/product/detail
   * @secure
   */
  getProductUsingPost = (
    查询条件参数: ChanPinChaXunShiTiLei,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiChanPinXinXi, void>({
      path: `/dsp-admin/api/products/product/detail`,
      method: "POST",
      body: 查询条件参数,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChanPinGuanLi
   * @name SimpleProductListUsingPost
   * @summary 分页查询产品列表,简易
   * @request POST:/dsp-admin/api/products/simple
   * @secure
   */
  simpleProductListUsingPost = (
    查询条件参数: ChanPinChaXunShiTiLei,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageChanPinLieBiaoXiangYingXinXi, void>({
      path: `/dsp-admin/api/products/simple`,
      method: "POST",
      body: 查询条件参数,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChanPinGuanLi
   * @name UpdateProductUsingPut
   * @summary 更新产品
   * @request PUT:/dsp-admin/api/products/{id}
   * @secure
   */
  updateProductUsingPut = (
    productCreateDTO: ChanPinXinZengXinXi,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiInt, void>({
      path: `/dsp-admin/api/products/${id}`,
      method: "PUT",
      body: productCreateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags ChanPinGuanLi
   * @name DeleteProductUsingDelete
   * @summary 删除产品
   * @request DELETE:/dsp-admin/api/products/{id}
   * @secure
   */
  deleteProductUsingDelete = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/products/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new ChanPinGuanLi();
